import React from 'react';
import { TCandidate } from '../types';
import { Box, Typography } from '@mui/material';
import { styles } from './styles';
import { MatchScore } from '../types';
import { SCORE_DISPLAY_CONFIG } from './config';

const getScoreDisplay = (score: TCandidate['matching_conditions'][number]['matched_score']) => {
  if (score === null || score === undefined) {
    return SCORE_DISPLAY_CONFIG.PENDING;
  }

  return SCORE_DISPLAY_CONFIG[score as MatchScore] || SCORE_DISPLAY_CONFIG.PENDING;
};

export const CandidateExpandedContent = ({ item }: { item: TCandidate }) => {
  if (!item.matching_conditions.length)
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body1" color="text.secondary">
          No suitability analysis available for this candidate.
        </Typography>
      </Box>
    );

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, flexWrap: 'wrap' }}>
        {item.matching_conditions.map((condition) => {
          const { icon, text, color, bgColor } = getScoreDisplay(condition.matched_score);

          return (
            <Box key={condition.id} sx={styles.expandedContentContainer}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                <Box
                  sx={{
                    ...styles.scoreDisplayContainer,
                    backgroundColor: bgColor
                  }}
                >
                  {icon}
                  <Typography variant="body2" color={color} sx={{ fontWeight: 'medium' }}>
                    {text}
                  </Typography>
                </Box>
              </Box>

              <Typography
                variant="body2"
                sx={{ mb: 1.5, fontStyle: 'italic', color: 'text.secondary' }}
              >
                &ldquo;{condition.content}&rdquo;
              </Typography>

              <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
                {condition.suitability_comment}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
